import Form from "react-bootstrap/Form";

export function DateEdit(props) {
  const { id, label, value, helpText, onChange } = props;

  return (
    <Form.Group key={id} className="mt-3">
      <Form.Label className="fw-bold">{label}</Form.Label>
      <Form.Control type="date" placeholder={label} id={id} value={value} onChange={onChange} />
      {helpText && <Form.Text muted>{helpText}</Form.Text>}
    </Form.Group>
  );
}

export function SelectEdit(props) {
  const { id, label, items, value, helpText, onChange } = props;

  return (
    <Form.Group key={id} className="mt-3">
      <Form.Label className="fw-bold">{label}</Form.Label>
      <Form.Select id={id} onChange={onChange} value={value}>
        <option key="empty" value="">
          {`Select ${label}`}
        </option>
        {Object.keys(items).map((d) => (
          <option key={d} value={d}>
            {items[d].name}
          </option>
        ))}
      </Form.Select>
      {helpText && <Form.Text muted>{helpText}</Form.Text>}
    </Form.Group>
  );
}

export function TextEdit(props) {
  const { id, label, value, placeholder, disabled, helpText, onChange } = props;

  return (
    <Form.Group key={id} className="mt-3">
      <Form.Label className="fw-bold">{label}</Form.Label>
      <Form.Control type="text" placeholder={placeholder ?? label} id={id} value={value} disabled={disabled} onChange={onChange} />
      {helpText && <Form.Text muted>{helpText}</Form.Text>}
    </Form.Group>
  );
}
